import { ClinicalImpression } from "@medplum/fhirtypes";

import { TextWrapper } from "@/components/TextWrapper";
import { usDateTimeFormat } from "@/utils/datetime";

import { useEditSignature } from "./useEditSignature";

export default function EditSignature({
  clinicalImpression,
}: {
  clinicalImpression: ClinicalImpression;
}) {
  const { editorName, editHistory, lastUpdated } = useEditSignature(clinicalImpression);

  if (editHistory.length) {
    return (
      <>
        {editHistory.map(({ name, date }, i) => (
          <TextWrapper key={i} mb="xs" size="xs" c="dimmed" fs="italic">
            Edited by {name} {usDateTimeFormat(date)}
          </TextWrapper>
        ))}
      </>
    );
  }

  return (
    <TextWrapper mb="xs" size="xs" c="dimmed" fs="italic">
      Edited by {editorName} {usDateTimeFormat(lastUpdated)}
    </TextWrapper>
  );
}
